const PlusMinusCircle01Icon = /*#__PURE__*/ [
  ["path", { d: "M12 7.5V13.8636M15.5 10.6818H8.5M15.5 16.5H8.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["circle", { cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "1.5", key: "1" }]
];

export { PlusMinusCircle01Icon as default };
//# sourceMappingURL=PlusMinusCircle01Icon.js.map
